import Country from './Country';

const filterData = s3BasePath => [
  {
    url: `${s3BasePath}filters/flags/IT.png`,
    name: 'Italy',
    id: Country.italy(),
    iso: 'it',
  },
  {
    url: `${s3BasePath}filters/flags/GB.png`,
    name: 'United Kingdom',
    id: Country.unitedKingdom(),
    iso: 'uk',
  },
  {
    url: `${s3BasePath}filters/flags/FR.png`,
    name: 'France',
    id: Country.france(),
    iso: 'fr',
  },
  {
    url: `${s3BasePath}filters/flags/US.png`,
    name: 'United States',
    id: Country.unitedStates(),
    iso: 'us',
  },
  {
    url: `${s3BasePath}filters/flags/EU.svg`,
    name: 'European Union',
    id: 'eu',
    iso: 'eu',
  },
];

export default filterData;
